export const ar = {
  title: "التفضيلات",
  pageTitle: "التفضيلات",
  subtitle: "إدارة إعدادات مساحة العمل والتكوينات",
  pageSubtitle: "إدارة إعدادات مساحة العمل والتكوينات",
  metaTitle: "التفضيلات - OrderHub",
  metaDescription: "إدارة إعدادات مساحة العمل والتكوينات.",
  breadcrumb: "التفضيلات",
  workspace: {
    title: "اسم مساحة العمل",
    description: "إعادة تسمية مساحة عمل فريقك",
    nameLabel: "اسم مساحة العمل",
    nameHelper: "يظهر في جميع أنحاء التطبيق وفي الإشعارات",
    save: "حفظ الاسم",
    saved: "تم تحديث اسم مساحة العمل",
    saveError: "فشل تحديث اسم مساحة العمل",
    nameRequired: "لا يمكن أن يكون اسم مساحة العمل فارغًا",
  },
  display: {
    title: "العرض",
    description: "تفضيلات التنسيق الإقليمية",
    language: { label: "اللغة", helper: "لغة الواجهة والبريد لمساحة العمل هذه" },
    timeZone: { label: "المنطقة الزمنية", helper: "تُستخدم في جميع أنحاء التطبيق للطوابع الزمنية" },
    dateFormat: { label: "تنسيق التاريخ", helper: "كيفية عرض التواريخ في التطبيق" },
    timeFormat: { label: "تنسيق الوقت", helper: "كيفية عرض الأوقات في التطبيق" },
    timeFormat12h: "12 ساعة (1:30 م)",
    timeFormat24h: "24 ساعة (13:30)",
    save: "حفظ العرض",
  },
  thresholds: {
    title: "حدود المهام",
    description: "قواعد اكتشاف التأخير والقيمة العالية",
    save: "حفظ الحدود",
    overdue: {
      label: "حد التأخير (بالدقائق)",
      helper: "المهام الأقدم من هذا تُعلَّم كمتأخرة",
    },
    highValue: {
      label: "حد القيمة العالية",
      helper: "المهام الأعلى من هذه القيمة تُعلَّم ذات قيمة عالية",
    },
  },
  notifications: {
    title: "إشعارات البريد الإلكتروني",
    description: "تحكم في رسائل البريد التي تتلقاها",
    active: "{{active}}/{{total}} نشط",
    changesSaveAutomatically: "يتم حفظ التغييرات تلقائيًا",
  },
  vip: {
    title: "تصنيف VIP",
    description: "تصنيف العملاء تلقائيًا بناءً على سلوك الإنفاق",
    enabled: "مُفعَّل",
    disabled: "مُعطَّل",
    save: "حفظ إعدادات VIP",
    lifetimeSalesLabel: "إجمالي المبيعات ≥",
    lifetimeSalesPlaceholder: "مثال: 10000",
    completedOrdersLabel: "الطلبات المكتملة ≥",
    completedOrdersPlaceholder: "مثال: 25",
    conjunctionAnd: "و",
    qualifyNotice: "يؤهل العملاء عندما يتم استيفاء كلا الشرطين معًا. اضبط أيًا منهما على 0 لتعطيل التصنيف التلقائي.",
    toastSaved: "تم حفظ إعدادات VIP",
    toastSavedDescription: "جارٍ إعادة تصنيف العملاء في الخلفية.",
    lifetimeSalesRangeError: "يجب أن تكون إجمالي المبيعات بين {{min}} و{{max}}.",
    completedOrdersRangeError: "يجب أن تكون الطلبات المكتملة بين {{min}} و{{max}}.",
  },
  saved: "تم حفظ التفضيلات.",
  saveFailed: "فشل حفظ التفضيلات. حاول مرة أخرى.",
  whatsapp: {
    cardHeader: "قوالب واتساب",
    cardDescription: "تخصيص الرأس والرسالة المستخدمة عند فتح واتساب من نشاط",
    headerLabel: "الرأس",
    headerPlaceholder: "مثال: تأكيد الطلب",
    messageLabel: "الرسالة",
    messagePlaceholder: "مرحبًا {{customer_name}}، ...",
    variablesHint: "المتغيرات المتاحة: {{customer_name}}، {{order_number}}، {{order_items}}، {{amount}}، {{currency}}، {{checkout_url}}",
    save: "حفظ قوالب واتساب",
    saved: "تم حفظ قوالب واتساب.",
    saveError: "فشل حفظ قوالب واتساب.",
    templates: {
      confirmationNeeded: {
        label: "تأكيد الطلب",
        description: "تُرسل عند طلب تأكيد الطلب من العميل",
      },
      openDraftOrders: {
        label: "الطلبات المسودة المفتوحة",
        description: "تُرسل لتذكير العميل بطلب مسودة",
      },
      checkoutRecovery: {
        label: "استعادة السلة المتروكة",
        description: "تُرسل عند استعادة سلة متروكة",
      },
    },
  },
} as const;
